export default {
  categories: {
    shoes: 'Chaussures',
    hoodies: 'Hoodies / Sweats',
    tShirts: 'T-shirts',
    jackets: 'Vestes',
    pants: 'Pantalons / Shorts',
    headwear: 'Couvre-chefs',
    sets: 'Ensembles',
    underwear: 'Sous-vêtements',
    jersey: 'Maillot',
    accessories: 'Accessoires',
    bags: 'Sacs',
    belts: 'Ceintures',
    perfumes: 'Parfums',
    other: 'Autres articles',
  },
};